import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Loader from "../../Utils/Loader";
import classes from "./styles.module.css";

// Status pill
function StatusPill({ status }) {
    const statusConfig = {
        new: { label: "Новый", bg: "#e3f2fd", color: "#1565c0" },
        in_progress: { label: "В работе", bg: "#fff3e0", color: "#e65100" },
        resolved: { label: "Решен", bg: "#e8f5e9", color: "#2e7d32" },
        archived: { label: "Архив", bg: "#f5f5f5", color: "#757575" },
    };

    const config = statusConfig[status] || { label: status, bg: "#f5f5f5", color: "#666" };

    return (
        <span style={{ padding: "2px 8px", borderRadius: 12, background: config.bg, color: config.color, fontSize: 12 }}>
            {config.label}
        </span>
    );
}

// Empty state
function Empty() {
    return (
        <div className={classes.Empty}>
            <FormattedMessage id="DisputesList.empty" defaultMessage="Диспуты не найдены" />
        </div>
    );
}

function TableRow({ row, isActive, onClick }) {
    const intl = useIntl();
    const trClass = isActive ? `${classes.Row} ${classes.Active}` : classes.Row;

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        return d.toLocaleDateString(intl.locale) + " " + d.toLocaleTimeString(intl.locale, { hour: "2-digit", minute: "2-digit" });
    };

    const truncateText = (text, maxLength = 50) => {
        if (!text) return "-";
        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    };

    return (
        <tr className={trClass} onClick={() => onClick(row)} style={{ cursor: "pointer" }}>
            <td className={classes.CellCenter}>#{row.id}</td>
            <td className={classes.Cell}>
                <div className={classes.ChatInfo}>
                    <div className={classes.ChatTitle}>{truncateText(row.chatTitle, 20)}</div>
                    <div className={classes.SenderName}>{truncateText(row.senderName, 25)}</div>
                </div>
            </td>
            <td className={classes.Cell}>
                <div style={{ fontFamily: "monospace", fontSize: 13 }}>
                    {row.transactionId ? `#${row.transactionId}` : "-"}
                </div>
            </td>
            <td className={classes.Cell}>
                <div className={classes.MessagePreview}>{truncateText(row.messageText, 40)}</div>
                {row.hasAttachment && (
                    <span className={classes.AttachmentBadge}>
                        <FormattedMessage id="DisputesList.attachment" defaultMessage="Вложение" />
                    </span>
                )}
            </td>
            <td className={classes.Cell}>
                <div style={{ fontSize: 12 }}>{row.merchantName || "-"}</div>
            </td>
            <td className={classes.CellCenter}>
                <StatusPill status={row.status} />
            </td>
            <td className={classes.Cell}>
                <div style={{ fontSize: 11, opacity: 0.7 }}>{formatDate(row.createdAt)}</div>
            </td>
        </tr>
    );
}

function DisputesList({ data, currentId, isLoading, onSelect }) {
    const rows = Array.isArray(data) ? data : [];

    if (isLoading) return <Loader />;
    if (!rows.length) return <Empty />;

    return (
        <table className={classes.Table}>
            <thead>
                <tr>
                    <th className={classes.HeaderCenter}>
                        <FormattedMessage id="DisputesList.table.id" defaultMessage="Идентификатор" />
                    </th>
                    <th className={classes.HeaderCell}>
                        <FormattedMessage id="DisputesList.table.chat" defaultMessage="Чат / Отправитель" />
                    </th>
                    <th className={classes.HeaderCell}>
                        <FormattedMessage id="DisputesList.table.transaction" defaultMessage="Транзакция" />
                    </th>
                    <th className={classes.HeaderCell}>
                        <FormattedMessage id="DisputesList.table.message" defaultMessage="Сообщение" />
                    </th>
                    <th className={classes.HeaderCell}>
                        <FormattedMessage id="DisputesList.table.merchant" defaultMessage="Мерчант" />
                    </th>
                    <th className={classes.HeaderCenter}>
                        <FormattedMessage id="DisputesList.table.status" defaultMessage="Статус" />
                    </th>
                    <th className={classes.HeaderCell}>
                        <FormattedMessage id="DisputesList.table.date" defaultMessage="Дата" />
                    </th>
                </tr>
            </thead>
            <tbody>
                {rows.map((row) => (
                    <TableRow
                        key={row.id}
                        row={row}
                        isActive={currentId === row.id}
                        onClick={onSelect}
                    />
                ))}
            </tbody>
        </table>
    );
}

DisputesList.defaultProps = {
    data: [],
    isLoading: false,
    onSelect: () => {},
};

export default DisputesList;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/DisputesList/index.js